import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static targets = ["input"]
  static values = { url: String, personUrl: String }

  connect() {
    this.tomSelect = new window.TomSelect(this.inputTarget, {
      valueField: 'value',
      labelField: 'text',
      searchField: [],
      highlight: true,
      load: (query, callback) => {
        this.tomSelect.clearOptions()
        this.fetchResults(query, callback)
      },
      render: {
        option: (item, escape) => this.renderOption(item, escape),
        no_results: () => `<div class="no-results">${window.I18n.t('views.admin_home.search.no_results')}</div>`
      },
    })

    const labelledBy = this.inputTarget.getAttribute('aria-labelledby')
    if (labelledBy) {
      this.tomSelect.control_input.setAttribute('aria-labelledby', labelledBy)
    }

    this.tomSelect.hook('instead', 'addItem', (value) => {
      this.navigateToPerson(value)
    })
  }

  disconnect() {
    this.tomSelect?.destroy()
  }

  async fetchResults(query, callback) {
    try {
      const response = await get(this.urlValue, { query: { q: query }, responseKind: 'json' })
      if (response.ok) {
        callback(await response.json)
      } else {
        callback()
      }
    } catch (error) {
      callback()
    }
  }

  renderOption(item, escape) {
    const email = item.email ? `<span class="people-search__result-email">${escape(item.email)}</span>` : ''
    const phone = item.phone ? `<span class="people-search__result-phone">${escape(item.phone)}</span>` : ''
    return `<div class="people-search__result">
      <span class="people-search__result-name">${escape(item.text)}</span>
      ${email}
      ${phone}
    </div>`
  }

  navigateToPerson(value) {
    if (value) {
      window.location.href = `${this.personUrlValue}/${value}`
    }
  }
}
